import * as React from 'react';
import { Provider } from 'react-redux';
import { createFormStore } from 'sos-eservice-common/js/Redux/store.provider';
import { StatisticsOrderProps } from './StatisticsOrder.types';
import StatisticsOrderForm from './StatisticsOrderForm';
import { statisticsOrderStepValidationMap } from './statisticsOrderStepValidationMap';
import {setFormConfig} from 'sos-eservice-common/js/config';
import {StatisticsConfig} from './statisticsConfig';
import { getInitialState } from './init';

export class StatisticsOrder extends React.Component<
  StatisticsOrderProps,
  any
> {
  private store: ReturnType<typeof createFormStore>;
  constructor(props) {
    super(props);
    const {basePath, translations} = this.props;
    setFormConfig(new StatisticsConfig(translations, basePath, statisticsOrderStepValidationMap));
    const initalState = getInitialState(this.props);
    this.store = createFormStore(initalState);
  }

  render() {
    return (
      <Provider store={this.store}>
        <StatisticsOrderForm />
      </Provider>
    );
  }
}
